import React from 'react';
import { Phone, Video, MessageCircle, X } from 'lucide-react';

export interface FreeConsultationPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onStart: () => void;
  theme?: {
    primaryColor?: string;
    buttonBg?: string;
    buttonHoverBg?: string;
  };
}

export const FreeConsultationPopup: React.FC<FreeConsultationPopupProps> = ({
  isOpen,
  onClose,
  onStart,
  theme = {
    primaryColor: 'text-rose-600',
    buttonBg: 'bg-rose-600',
    buttonHoverBg: 'hover:bg-rose-700',
  },
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4">
      <div className="bg-white rounded-3xl shadow-xl max-w-sm w-full p-6 relative text-center animate-in fade-in zoom-in-95 duration-200">
        {/* CLOSE */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-slate-400 hover:text-slate-600 cursor-pointer p-1 transition-colors"
          aria-label="Close modal"
        >
          <X className="w-5 h-5" />
        </button>

        {/* ICON */}
        <div className="text-5xl mb-4">🎁</div>

        {/* TITLE */}
        <h2 className="text-xl font-extrabold text-slate-900 mb-2">
          Your First 3-Minutes Consultation is Absolutely FREE!
        </h2>

        <p className="text-sm text-slate-600 mb-4 leading-relaxed">
          Enjoy your first Chat, Call or Video consultation with any astrologer.
        </p>

        {/* OPTIONS */}
        <div className="flex justify-between mb-4 text-xs font-semibold px-2">
          <div className="flex flex-col items-center gap-1">
            <MessageCircle className="w-5 h-5 text-purple-500" />
            <span>Chat FREE</span>
          </div>
          <div className="flex flex-col items-center gap-1">
            <Phone className="w-5 h-5 text-green-500" />
            <span>Call FREE</span>
          </div>
          <div className="flex flex-col items-center gap-1">
            <Video className="w-5 h-5 text-pink-500" />
            <span>Video FREE</span>
          </div>
        </div>

        {/* BADGE */}
        <div className="text-xs text-orange-500 font-semibold mb-4">
          ⚡ Only for first-time users
        </div>

        {/* CTA */}
        <button
          onClick={onStart}
          className={`w-full py-3 rounded-full text-white font-bold transition-all shadow-md cursor-pointer ${
            theme.buttonBg || 'bg-rose-600'
          } ${theme.buttonHoverBg || 'hover:bg-rose-700'}`}
        >
          Start Free Consultation
        </button>

        <button
          onClick={onClose}
          className="text-xs text-slate-500 hover:text-slate-700 mt-3 cursor-pointer block mx-auto transition-colors"
        >
          Maybe Later
        </button>
      </div>
    </div>
  );
};